const links = [
  {
    menuName: 'Laguna Isles Living',
    menuItems: [
      {
        text: 'Vision',
        route: 'vision',
      },
      {
        text: 'Master Plan',
        route: 'overall-site-plan',
      },
      {
        text: 'Phase One Site Plan',
        route: 'phase-one-site-plan',
      },
      {
        text: 'Activities',
        route: 'activities',
      },
      {
        text: 'Conservation',
        route: 'conservation',
      },
      {
        text: 'Port Aransas Calendar',
        route: 'port-aransas',
      },
    ],
  },

  {
    menuName: 'Build Your Home',
    menuItems: [
      {
        text: 'Our Architects',
        route: 'our-architect',
      },
      {
        text: 'Preferred Builders',
        route: 'approved-builders',
      },
      {
        text: 'Investment',
        route: 'investment',
      },
      {
        text: 'Building Process',
        route: 'building-process',
      },
    ],
  },

  {
    menuName: 'Contact Us',
    menuItems: [
      {
        text: 'Contact Us',
        route: 'contact-us',
      },
      {
        text: 'Directions',
        route: 'directions',
      },
    ],
  },
];

for (let i = 0; i < links.length; i += 1) {
  links[i]._id = `primary-${i}`;
  for (let j = 0; j < links[i].menuItems.length; j += 1) {
    links[i].menuItems[j]._id = `secondary-${j}`;
  }
}

export default links;



// WEBPACK FOOTER //
// ./src/components/MenuLinks.js